import {Component, OnInit, OnDestroy} from "@angular/core";
import {BusinessService} from "../../../services/data/business.service";
import {FamilyAlbum} from "../../../model/family-album";
import {Router, ActivatedRoute} from "@angular/router";
import {UrlService} from "../../../services/url.service";
import {Picture} from "../../../model/picture";
import {Page} from "../../../model/page";
import {CurrentEventService} from "../../../services/communication/currentEventService";
import {UploadService} from "../../../services/uploadService";
import {User} from "../../../model/user";
import {UserService} from "../../../services/data/user.service";
import {CommentService} from "../../../services/data/comment.service";
import {Comment} from "../../../model/comment";
import {PhotoSwipeService} from "../../photoswipe/photo-swipe.service";
import {NotificationsService} from "angular2-notifications/components";
import {BusinessRight} from "../../../model/business-right";
import {AuthentService} from "../../../services/authent.service";
import {DateFormatter} from "../../../model/date-formatter";
import {Business} from "../../../model/business";
import {CurrentBusinessService} from "../../../services/communication/currentBusinessService";
import {PictureDetailService} from "../../event/picture-detail/picture-detail.service";
import {Subscription} from "rxjs";

declare const $: any;

@Component({
  selector: 'public-event',
  template: require('./public-event.component.html'),
  styles: [
    require('./public-event.component.scss')
  ]
})

export class PublicEventComponent implements OnInit, OnDestroy {

  PAGE_SIZE: number = 25;

  model: FamilyAlbum;
  eventId: number;
  currentEvent: FamilyAlbum;

  activeTab: string = 'photos';

  isLoadingPicture: boolean = false;

  picturesModel: Picture[] = new Array<Picture>();
  picturePage: Page<Picture> = null;
  picturePageNumber = 0;

  isLoadingUser: boolean = false;

  members: User[] = new Array<User>();
  emails: string = "";

  isLoadingComment: boolean = false;

  comments: Comment[] = new Array<Comment>();
  commentPage: Page<Comment> = null;
  commentPageNumber: number = 0;

  pictureToDelete: number;
  memberToDelete: User = new User();
  commentToDelete: Comment = new Comment();

  userRight: BusinessRight;

  coverHeight: number;
  topMinified: boolean = false;
  topMinimum: boolean = false;

  /** Edition form **/
  editModel: FamilyAlbum = new FamilyAlbum();
  submitted = false;

  inputDate: string = "";

  date: number;
  isPublic: boolean = false;
  isDateValid: boolean = true;

  myDatePickerOptions = {
    todayBtnTxt: 'Aujourd\'hui',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    inline: false,
    locale: 'fr',
    dateFormat: 'dd/mm/yyyy',
    selectionTxtFontSize: '16px'
  };

  /** Show option on picture **/
  showedOption: number = -1;

  coverToSet: number;

  business: Business = new Business();

  private paramSubscription: Subscription = null;

  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
  }

  ngOnInit() {
    this.paramSubscription = this.activatedRoute.params.subscribe(
      (param: any) => {
        this.eventId = param['eventId'];

        if (this.currentEventService.currentEvent != null) {
          this.eventLoaded(this.currentEventService.currentEvent);
        } else {
          this.businessService.getEvent(this.eventId).subscribe(
            event => this.eventLoaded(event)
          );
        }

        this.loadPictures(1);
      });
  }

  ngAfterViewInit() {
  }

  constructor(private businessService: BusinessService, private router: Router,
              private urlService: UrlService, private activatedRoute: ActivatedRoute,
              private currentEventService: CurrentEventService,
              private uploadService: UploadService, private authent: AuthentService,
              private userService: UserService, private commentService: CommentService,
              private photoSwipeService: PhotoSwipeService, private notificationService: NotificationsService,
              private pictureDetailService: PictureDetailService, private currentBusinessService: CurrentBusinessService) {

    if (authent.getRight() == null) {
      authent.userRight$.subscribe(
        right => {
          this.userRight = right;
        }
      );
    } else {
      this.userRight = authent.getRight();
    }

    photoSwipeService.pictureChange$.subscribe(
      state => {
        if (state == 'afterChange') {
          this.onScroll();
        }

        if (state == 'closed') {
          this.closeViewer();
        }
      }
    );

    this.bindPageScroll();

    if (currentBusinessService.currentBusiness.logoPath != null) {
      this.business = currentBusinessService.currentBusiness;
    }

    currentBusinessService.businessChange$.subscribe(business => this.business = business);
  }

  showUpload() {
    this.uploadService.changeShow(true);
  }

  activateTab(tabName: string) {
    if (tabName == 'comments') {
      this.loadComments(1);
    }

    if (tabName == 'members') {
      this.loadUsers();
    }

    this.activeTab = tabName;
  }

  eventLoaded(event: FamilyAlbum) {
    this.currentEventService.changeEvent(event);
    this.currentEvent = this.currentEventService.currentEvent;
    this.editModel = JSON.parse(JSON.stringify(event));
    this.inputDate = DateFormatter.format(this.editModel.date);
    this.date = this.editModel.date;
  }

  setPictureToDelete(pictureId: number, event) {
    event.stopPropagation();
    this.pictureToDelete = pictureId;
    this.pageClick();
  }

  showOptions(event, pictureId: number) {
    event.stopPropagation();
    this.showedOption = pictureId;
  }

  pageClick() {
    this.showedOption = -1;
  }

  changeCoverToSet(pictureId: number) {
    this.coverToSet = pictureId;
  }

  changeCover() {
    this.businessService.updateCover(this.currentEvent.id, this.coverToSet).subscribe(
      event => {
        this.currentEventService.changeEvent(event);
        this.currentEvent = this.currentEventService.currentEvent;
        this.pageClick();
      }
    )
  }

  setMemberToDelete(member: User) {
    this.memberToDelete = member;
  }

  setCommentToDelete(comment: Comment) {
    this.commentToDelete = comment;
  }

  edit() {
    this.uploadService.changeShow(false);
    this.router.navigateByUrl('/event/' + this.currentEvent.id + '/edit');
  }

  loadPictures(page?: number) {
    this.isLoadingPicture = true;

    if (page == null) {
      this.picturePageNumber++;
    } else {
      this.picturePageNumber = page;
    }

    this.businessService.eventPictures(this.eventId, this.picturePageNumber, this.PAGE_SIZE).subscribe(
      page => this.picturesLoaded(page)
    );
  }

  loadUsers() {
    if (!this.isLoadingUser) {
      this.isLoadingUser = true;

      this.members = new Array<User>();

      this.userService.getEventMembers(this.eventId).subscribe(
        members => this.membersLoaded(members)
      );
    }
  }

  loadComments(page?: number) {
    if (!this.isLoadingComment && (this.commentPage == null || (this.commentPage != null && !this.commentPage.last))) {
      this.isLoadingComment = true;

      if (page == null) {
        this.commentPageNumber++;
      } else {
        this.commentPageNumber = page;
      }

      this.commentService.getEventComments(this.eventId, this.commentPageNumber, this.PAGE_SIZE).subscribe(
        comments => this.commentsLoaded(comments)
      );
    }
  }

  onScroll() {
    if (!this.isLoadingPicture && !this.picturePage != null && !this.picturePage.last) {
      this.loadPictures();
    }
  }

  back() {
    this.uploadService.changeShow(false);
    this.router.navigateByUrl('/home/events');
    this.currentEventService.changeEvent(null);
  }

  picturesLoaded(page: Page<Picture>) {
    this.picturePage = page;

    if (this.picturePageNumber == 1) {
      this.picturesModel = new Array<Picture>();
    }

    for (let picture of page.content) {
      picture.miniatureUrl = this.urlService.getPictureMiniatureUrl(this.eventId, picture.id);
      picture.url = this.urlService.getPictureUrl(this.eventId, picture.id);
      if (picture.owner != null) {
        picture.owner.avatarUrl = this.urlService.getMemberAvatarUrl(picture.owner.id);
      }

      this.picturesModel.push(picture);
    }

    if (this.picturePageNumber > 1) {
      this.photoSwipeService.addPictures(page.content);
    }

    this.isLoadingPicture = false;
  }

  openPicture(index: number) {
    this.photoSwipeService.openGallery(this.picturesModel, true, index);
    this.pictureDetailService.openDetail(this.picturesModel[index]);
  }

  commentsLoaded(page: Page<Comment>) {
    this.commentPage = page;
    this.currentEvent.nbComments = page.totalElements;

    if (this.commentPageNumber == 1) {
      this.comments = new Array<Comment>();
    }

    for (let comment of page.content) {
      comment.owner.avatarUrl = this.urlService.getMemberAvatarUrl(comment.owner.id);
      this.comments.push(comment);
    }

    this.isLoadingComment = false;
  }

  membersLoaded(members: User[]) {
    for (let member of members) {
      member.avatarUrl = this.urlService.getMemberAvatarUrl(member.id);

      this.members.push(member);
    }

    this.currentEvent.members = members;
    this.isLoadingUser = false;
  }


  deleteMember() {
    this.businessService.removeMember(this.currentEvent.id, this.memberToDelete.id).subscribe(
      reponse => {
        let index = this.members.map(function (member) {
          return member.id;
        }).indexOf(this.memberToDelete.id);

        this.members.splice(index, 1);

        index = this.currentEvent.members.map(function (member) {
          return member.id;
        }).indexOf(this.memberToDelete.id);

        this.currentEvent.members.splice(index, 1);
      }
    );
  }

  deletePicture() {
    this.businessService.deleteEventPictures(this.eventId, [this.pictureToDelete]).subscribe(
      response => {
        let index = this.picturesModel.map(function (picture) {
          return picture.id;
        }).indexOf(this.pictureToDelete);

        this.picturesModel.splice(index, 1);
        this.picturePage.totalElements--;
      }
    );
  }

  deleteComment() {
    this.commentService.deleteComment(this.currentEvent.id, this.commentToDelete.id).subscribe(
      response => {
        let index = this.comments.map(function (comment) {
          return comment.id;
        }).indexOf(this.commentToDelete.id);

        this.comments.splice(index, 1);
        this.currentEvent.nbComments--;
      }
    );
  }

  commentClick(commentId: number) {
    this.commentService.getPictureFromComment(commentId).subscribe(
      picture => {
        picture.miniatureUrl = this.urlService.getPictureMiniatureUrl(this.currentEvent.id, picture.id);
        picture.url = this.urlService.getPictureUrl(this.currentEvent.id, picture.id);
        picture.owner.avatarUrl = this.urlService.getMemberAvatarUrl(picture.owner.id);
        this.photoSwipeService.openGallery([picture], true);
        this.pictureDetailService.openDetail(picture);
      }
    );
  }

  inviteMember() {
    this.businessService.inviteMembers(this.currentEvent.id, this.emails).subscribe(
      errors => {
        if (errors.length == 0) {
          this.notificationService.success('Invitations', 'Vos invitations ont été envoyé');
        } else {
          for (let error of errors) {
            this.notificationService.error('Invitations', error.email + ' : ' + error.message);
          }
        }

        this.loadUsers();
      }
    );

  }

  bindPageScroll() {
    let that = this;

    that.handleTopSize();

    $(window).scroll(function (event) {
      that.handleTopSize();
    });

    $(window).resize(function (event) {
      that.handleTopSize();
    });
  }

  handleTopSize() {
    let scroll = $(window).scrollTop();
    let $topProfile = $('.top-cover');

    this.coverHeight = $(window).height() / 2;

    let size = this.coverHeight - scroll;

    if (size > 200) {
      $topProfile.height(this.coverHeight - scroll);
      this.topMinimum = false;
    } else {
      this.topMinimum = true;
    }

    if (size < (this.coverHeight / 3 * 2)) {
      this.topMinified = true;
    } else {
      this.topMinified = false;
    }
  }

  onDateChanged(event: any) {
    if (event.formatted != undefined && event.formatted != "") {
      this.isDateValid = true;
      this.date = event.epoc * 1000;
    } else {
      this.isDateValid = false;
    }
  }

  updateEvent() {
    this.editModel.date = this.date;

    this.businessService.updateEvent(this.editModel).subscribe(
      event => {
        this.currentEventService.changeEvent(event);
        this.currentEvent = this.currentEventService.currentEvent;
        this.notificationService.success('Evénement', 'Les modifications ont été appliquées');
      }
    );
  }

  delete() {
    this.businessService.deleteEvent(this.editModel.id).subscribe(
      response => this.router.navigateByUrl('/home/events')
    );
  }

  private closeViewer() {
    this.pictureDetailService.changePicture(null);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/public/event/public-event.component.ts